"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dateOnly = dateOnly;
exports.inBounds = inBounds;
exports.wrapDisabledDateWithBound = wrapDisabledDateWithBound;
exports.correctTimeWithBounds = correctTimeWithBounds;
function dateOnly(date) {
    var ret = new Date(date);
    ret.setHours(0, 0, 0, 0);
    return ret;
}

function inBounds(_ref, value) {
    var altLowerBound = _ref.altLowerBound,
        altUpperBound = _ref.altUpperBound;

    return !(altLowerBound && value < altLowerBound || altUpperBound && value > altUpperBound);
}

function wrapDisabledDateWithBound(disabledDate, _ref2) {
    var altLowerBound = _ref2.altLowerBound,
        altUpperBound = _ref2.altUpperBound;

    return function (value) {
        return disabledDate(value) || value < altLowerBound || value > altUpperBound;
    };
}

function correctTimeWithBounds(_ref3, value) {
    var altLowerBound = _ref3.altLowerBound,
        altUpperBound = _ref3.altUpperBound;

    if (altLowerBound && value < altLowerBound) {
        value = altLowerBound;
    }
    if (altUpperBound && value > altUpperBound) {
        value = altUpperBound;
    }
    return value;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-date-range-picker@0.0.3@@alicd/crui-date-range-picker/lib/boundUtils.js
// module id = 264
// module chunks = 0